import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const UGCAgenturKoeln = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/?lang=de");
    }, 100);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>UGC Agentur Köln | AI UGC Creator Köln | Fuel72</title>
        <meta
          name="description"
          content="UGC Agentur Köln: Professionelle AI UGC Videos für Kölner Unternehmen. UGC Creator Köln ohne Influencer. 72 Stunden Lieferung. ✓ Kreativ ✓ Schnell ✓ Günstig"
        />
        <meta
          name="keywords"
          content="ugc agentur köln, ugc creator köln, ugc köln, ai ugc köln, ugc videos köln, content creator köln, ugc werbung köln, ugc nrw"
        />
        <link rel="canonical" href="https://www.fuel72.com/ugc-agentur-koeln" />
        
        {/* Hreflang */}
        <link rel="alternate" hrefLang="de" href="https://www.fuel72.com/ugc-agentur-koeln" />
        <link rel="alternate" hrefLang="de-DE" href="https://www.fuel72.com/ugc-agentur-koeln" />
        <link rel="alternate" hrefLang="en" href="https://www.fuel72.com/hire-ugc" />
        
        {/* Open Graph */}
        <meta property="og:title" content="UGC Agentur Köln | AI UGC Creator | Fuel72" />
        <meta property="og:description" content="UGC Videos für Kölner Unternehmen. Kreativ, authentisch, schnell." />
        <meta property="og:url" content="https://www.fuel72.com/ugc-agentur-koeln" />
        <meta property="og:locale" content="de_DE" />
        
        {/* Geo Tags */}
        <meta name="geo.region" content="DE-NW" />
        <meta name="geo.placename" content="Köln" />
        <meta name="geo.position" content="50.937531;6.960279" />
        <meta name="ICBM" content="50.937531, 6.960279" />

        {/* Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Fuel72 - UGC Agentur Köln",
            "description": "Kreative AI UGC Videos für Kölner Unternehmen. Die Medienstadt verdient besten Content.",
            "url": "https://www.fuel72.com/ugc-agentur-koeln",
            "telephone": "+4917687870011",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Köln",
              "addressRegion": "Nordrhein-Westfalen",
              "addressCountry": "DE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "50.937531",
              "longitude": "6.960279"
            },
            "areaServed": [
              { "@type": "City", "name": "Köln" },
              { "@type": "City", "name": "Düsseldorf" },
              { "@type": "State", "name": "Nordrhein-Westfalen" }
            ],
            "priceRange": "€€"
          })}
        </script>
      </Helmet>

      <main className="min-h-screen gradient-mesh flex items-center justify-center">
        <div className="container mx-auto px-4 py-20 text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
            UGC Agentur{" "}
            <span className="bg-gradient-to-r from-neon-purple via-neon-pink to-orange-500 bg-clip-text text-transparent">
              Köln
            </span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Kreative AI UGC Videos für Kölner Unternehmen. 
            Die Medienstadt verdient den besten Content.
          </p>
          
          <div className="max-w-3xl mx-auto text-left space-y-6">
            <h2 className="text-2xl font-bold">UGC für die Medienstadt Köln</h2>
            <p className="text-muted-foreground">
              Köln ist Deutschlands Medien-Hauptstadt. RTL, WDR und unzählige Agenturen 
              sind hier zuhause. Mit Fuel72 erhalten auch kleinere Kölner Unternehmen 
              Zugang zu professionellem Video-Content – powered by AI.
            </p>
            
            <h2 className="text-2xl font-bold mt-8">Branchen in Köln & NRW</h2>
            <ul className="space-y-2 text-muted-foreground">
              <li>📺 Medien & Entertainment</li>
              <li>🍻 Brauereien & Gastronomie</li>
              <li>🎭 Events & Kultur</li>
              <li>🛒 E-Commerce & Retail</li>
              <li>🏭 Industrie & B2B</li>
            </ul>
            
            <h2 className="text-2xl font-bold mt-8">Auch für Düsseldorf & NRW</h2>
            <p className="text-muted-foreground">
              Fuel72 ist die digitale UGC Agentur für ganz NRW. Ob Köln, Düsseldorf, 
              Dortmund oder Essen – wir liefern professionelle AI UGC Videos in 72 Stunden.
            </p>
          </div>
          
          <p className="text-sm text-muted-foreground mt-12">Weiterleitung zur Hauptseite...</p>
        </div>
      </main>
    </>
  );
};

export default UGCAgenturKoeln;
